import React from 'react';
import './CategoryHub.css';
import { useNavigate } from 'react-router-dom';

const categories = [
  {
    title: "New Arrivals",
    imageUrl: require('../../assets/categories/newarrivals.jpg'),
    link: '/category/new-arrivals'
  },
  {
    title: "Shirts & Polos",
    imageUrl: require('../../assets/categories/shirts.png'),
    link: '/category/limited-edition'
  },
  {
    title: "Bottoms & Pants",
    imageUrl: require('../../assets/categories/bottoms.png'),
    link: '/category/bottoms-and-pants'
  },
  {
    title: "Suits & Tuxedos",
    imageUrl: require('../../assets/categories/tux.png'),
    link: '/category/suits-and-tuxedos'
  },
  {
    title: "Men's Accessories",
    imageUrl: require('../../assets/categories/bags.png'),
    link: '/category/mens-accessories'
  },
  {
    title: "Shoes",
    imageUrl: require('../../assets/categories/shoesi.png'),
    link: '/category/mens-shoes'
  },
  {
    title: "Glasses",
    imageUrl: require('../../assets/categories/accs.png'),
    link: '/category/mens-clothing'
  },
  {
    title: "Limited Edition",
    imageUrl: require('../../assets/categories/limited.png'),
    link: '/category/limited-edition'
  }
];

const CategoryHub = () => {
  const navigate = useNavigate();

  return (
    <section className="categoryhub">
      <h2 className="category-title">Shop by Category</h2>
      <div className="category-grid">
        {categories.map((cat, idx) => (
          <div
            key={idx}
            onClick={() => navigate(cat.link)}
            className="category-card"
          >
            <img
              src={cat.imageUrl}
              alt={cat.title}
              className="category-image"
            />
            <p className="category-name">{cat.title}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CategoryHub;
